import { defineAction } from '~/prix'
import questionOptionListAction from './questionOptionList.action.json' with { type: 'json' }
import { questionOptionObject } from '../questionOptionObject'
import { z } from 'zod'

const questionOptionListDefinition = defineAction({
  ...questionOptionListAction,
  input: z.object({}),
  output: z.object({
    items: z.array(questionOptionObject),
    count: z.number(),
  }),
})

export default questionOptionListDefinition
